import React from 'react'
import ContactTable from './ContactTable';
import { VStack } from '@chakra-ui/react';

const Contact = () => {
  return (
    <VStack
      w={"100%"}
      spacing={2}
      align="stretch"
      borderRadius="md"
    >
      <ContactTable />
    </VStack>
  );
}

export default Contact